import * as types from "../actions/types";

const INITIAL_STATE = {
  currentLocation: null,
  page: 1,
  limit: Number.MAX_SAFE_INTEGER,
  filter: null,
  name: "",
  sort: "mostClosest",
  rewardsOnly: null
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SET_SEARCH_SETTINGS:
      return { ...state, ...action.payload };

    case types.CLEAR_CURRENT_LOCATION:
      return { ...state, currentLocation: null };

    case types.CLEAR_SEARCH_FILTER:
      return {
        ...state,
        filter: null,
        name: "",
        sort: "mostClosest",
        rewardsOnly: null
      };

    default:
      return state;
  }
};
